<template>
    <div>
        <div class="mb-3">
            <div style="position: relative; margin-bottom: 5px;" v-if="image">
                <a :href="image.internal_urls.original" target="_blank">
                    <img :alt="image.alt_name" :src="image.internal_urls.small" style="width: 100%;">
                </a>
                <button type="button" @click="removeImage" class="btn btn-xxs btn-danger" style="position: absolute; top: -5px; right: -5px;"><i class="icon-cross3"></i></button>
            </div>
            <button class="btn" :class="btnClass" @click="showModal" type="button"><i v-if="btnIcon" class="mr-2" :class="btnIcon"></i>{{ btnText }}</button>
        </div>

        <b-modal :id="'modal-' + uuid" title="Mediabank" @hidden="showing = false" @show="showing = true" size="lg" ok-only ok-variant="light" ok-title="Stäng">
            <div v-if="showing">
                <mediabank-browser
                    :category-id="categoryId"
                    :category-locked="categoryLocked"
                    :upload="upload"
                    @select="selectImage"
                    modal
                />
            </div>
        </b-modal>
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import { debounce } from 'lodash';
import Vue from 'vue';
import { genUUID } from '@services/Helpers';
import MediabankBrowser from '@components/MediabankBrowser.vue';

export default {
    name: 'MediabankSelector',
    components: {
        MediabankBrowser,
    },
    props: {
        value: null,
        btnText: {
            type: String,
            default: 'Bläddra',
        },
        btnClass: {
            type: String,
            default: 'btn-primary',
        },
        btnIcon: {
            type: String,
            default: '',
        },
        thumbnail: {
            type: Boolean,
            default: false,
        },
        upload: {
            type: Boolean,
            default: false,
        },
        categoryId: {
            type: Number,
            default: 0,
        },
        categoryLocked: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        uuid: '198547632',
        showing: false,
        image: null,
        // eslint-disable-next-line func-names
        getImage: debounce(function (val) {
            const vm = this;
            this.image = null;
            // eslint-disable-next-line no-restricted-globals
            if (val && !isNaN(parseInt(val, 10))) {
                apiClient.get('/vue/mediabank/images/' + val)
                    .then((response) => {
                        Vue.set(vm, 'image', response.data);
                    });
            }
        }, 500),
    }),
    created() {
        this.uuid = genUUID();
        this.getImage(this.value);
    },
    watch: {
        value(val) {
            this.getImage(val);
        },
    },
    methods: {
        showModal() {
            this.$bvModal.show('modal-' + this.uuid);
        },
        selectImage(image) {
            this.$emit('input', image.image_id);
            this.$bvModal.hide('modal-' + this.uuid);
        },
        removeImage() {
            this.$emit('input', null);
        },
    },
};
</script>
